import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ProblemApi extends BaseApi {
    constructor(client) {
        super(client, '/problem');
    }

    async listCandidates(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/candidates`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getCandidatesSummary() {
        try {
            const response = await this.client.get(`${this.basePath}/candidates/summary`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getCandidate(id) {
        try {
            const response = await this.client.get(`${this.basePath}/candidates/${id}`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async acceptCandidate(id, data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/candidates/${id}/accept`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async dismissCandidate(id) {
        try {
            const response = await this.client.post(`${this.basePath}/candidates/${id}/dismiss`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async listSuggestionsForTicket(ticketId) {
        try {
            const response = await this.client.get(`${this.basePath}/tickets/${ticketId}/suggestions`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async listLinkedTickets(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/tickets`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
